import ForumIcon from "@mui/icons-material/Forum";
import ContactsIcon from "@mui/icons-material/Contacts";
import CampaignIcon from "@mui/icons-material/Campaign";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import SendIcon from "@mui/icons-material/Send";

export const chatMenu = [
  {
    section: "Messaging",
    key: "inbox",
    label: "Inbox",
    path: "/chat/inbox",
    icon: <ForumIcon />,
  },

  // Commented out - Template handling is now inside Chat Inbox flow
  // {
  //   key: "templates",
  //   label: "Templates",
  //   path: "/chat/templates",
  //   icon: <CampaignIcon />,
  // },

  // Commented out - Analytics disabled, kept only Chat module active
  // {
  //   key: "analytics",
  //   label: "Analytics",
  //   path: "/chat/analytics",
  //   icon: <AnalyticsIcon />,
  // },
];
